const routeConstant = {
  login: {
    path: "/login",
    title: "Login",
  },
  dashboard: {
    path: "/dashboard/home",
    title: "Dashboard",
  },
  dashboardCustomers: {
    path: "/dashboard/customers",
    title: "Customers",
  },
  dashboardSuppliers: {
    path: "/dashboard/suppliers",
    title: "Suppliers",
  },
  dashboardTransactions: {
    path: "/dashboard/transactions",
    title: "Transactions",
  },
  dashboardBlogs: {
    path: "/dashboard/blogs",
    title: "Blogs",
  },
  dashboardPolicies: {
    path: "/dashboard/policies",
    title: "Policies",
  },
  dashboardSupportMessages: {
    path: "/dashboard/supportMessages",
    title: "Support Messages",
  },
  dashboardNewsletterEmails: {
    path: "/dashboard/newsletterEmails",
    title: "Newsletter Emails",
  },
  dashboardSettings: {
    path: "/dashboard/settings",
    title: "Settings",
  },
};

export { routeConstant };
